import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as RequestActions from "../../../actions/requestActions";
import Plan from "./plan";
import plansConfig from "../../../constatns/pricing";
import "./index.css";
import { getPlans } from "../../../api";

class PricingPlans extends Component {
  constructor(props) {
    super(props);
    this.state = { tab: "application", plans: [] };
    this.clickHandler = this.clickHandler.bind(this);
    this.planWrapperWidth = this.planWrapperWidth.bind(this);
    this.invoiceClickHandler = this.invoiceClickHandler.bind(this);
  }

  clickHandler(e) {
    //const tab = e.target.dataset.tag;
    //console.log('tab', tab)
    //if(tab) { this.setState({tab}) }
  }

  componentDidMount() {
    getPlans(this.props.lang)
      .then((response) => {
        this.setState({ plans: response });
      })
      .catch((error) => console.error("getPlans", error));
  }

  planWrapperWidth(planLength) {
    if (window.matchMedia("(max-width: 820px)").matches) {
      return "100%";
    } else {
      return 100 / planLength + "%";
    }
  }

  invoiceClickHandler(pdfInfo) {
    this.props.onInvoiceClick(pdfInfo);
  }

  render() {
    const { lang } = this.props;
    const { tab, plans } = this.state;
    return (
      <div className="pricing-component">
        <div className="router-buttons-wrapper">
          <div
            style={{
              backgroundColor: tab === "application" ? "#f8f9fb" : "#f1f1f1",
              opacity: tab === "application" ? 1 : 0.5,
            }}
            data-tag={"application"}
            onClick={this.clickHandler}
            className="just-bv-header"
          >
            {lang === "fa"
              ? "بسته‌های اشتراک بورس ویو "
              : "BourseView Application"}
          </div>
          {/* <div style={{backgroundColor:tab==='application'?'#fbfaf9':'#f1f1f1',opacity: tab==='application'? 1: .5}} 
            data-tag={'application'} onClick={this.clickHandler} className='application-button'>
            {tab==='application'?<u>{lang === 'fa'? 'اشتراک بورس ویو ':'BourseView Application'}</u> :(lang === 'fa'? 'اشتراک بورس ویو':'BourseView Application')}
            <div style={{display:tab==='application'?'block':'none'}} className='separator-left'></div>
          </div> */}
          {/* <div style={{backgroundColor:tab==='api'?'#fbfaf9':'#f1f1f1',opacity: tab==='api'? 1: .5}} 
            data-tag={'api'} onClick={this.clickHandler} className='api-button'>
            {tab==='api'?<u>{lang === 'fa'? 'وب سرویس':'API'}</u> :(lang === 'fa'? 'وب سرویس':'API')}
            <div data-tag={'api'} onClick={this.clickHandler} style={{display:tab==='api' || tab==='excel'?'block':'none'}} className='separator-right'></div>
            <div data-tag={'api'} onClick={this.clickHandler} style={{display:tab==='application' || tab==='api'?'block':'none'}} className='separator-left'></div>
          </div> */}
          {/* <div style={{backgroundColor:tab==='excel'?'#fbfaf9':'#f1f1f1',opacity: tab==='excel'? 1: .5}} 
            data-tag={'excel'} onClick={this.clickHandler} className='api-button'>
            {tab==='excel'?<u>{lang === 'fa'? 'خدمات اکسل':'Excel Addin'}</u> :(lang === 'fa'? 'خدمات اکسل':'Excel Addin')}
            <div style={{display:tab==='excel'?'block':'none'}} className='separator-right'></div>
          </div> */}
        </div>
        <div className="container">
          <Plans
            tab={tab}
            lang={lang}
            planWrapperWidth={this.planWrapperWidth}
            onInvoiceClick={this.invoiceClickHandler}
            plans={plans}
          />
        </div>
      </div>
    );
  }
}

const Plans = (props) => {
  
  if (props.tab === "api") {
    const wrapperWidth = props.planWrapperWidth(plansConfig.api.length);
    return plansConfig.api.map((item, index) => {
      var wrapperBorder;
      if (index === 0) {
        wrapperBorder = "0 1px 0 0";
      } else if (index === plansConfig.api.length - 1) {
        wrapperBorder = "0 0 0 1px";
      } else {
        wrapperBorder = "0 1px 0 1px";
      }
      return (
        <Plan
          wrapperBorder={wrapperBorder}
          wrapperWidth={wrapperWidth}
          key={item.id + index}
          plan={item}
          lang={props.lang}
          onInvoiceClick={props.onInvoiceClick}
          backgroundColor={index > 2 ? 'black':'blue'}
        />
      );
    });
  } else if (props.tab === "application") {
    return props.plans.map((item, index) => {
      if(!item.displayName) return <></> 
      return (
        <div className="column">
          <Plan
            key={item.id + index}
            plan={item}
            lang={props.lang}
            onInvoiceClick={props.onInvoiceClick}
            backgroundColor={index > 2 ? 'black':'blue'}
          />
        </div>
      );
    });
  } else if (props.tab === "excel") {
    const wrapperWidth = props.planWrapperWidth(plansConfig.excel.length);
    return plansConfig.excel.map((item, index) => {
      var wrapperBorder;
      if (index === 0) {
        wrapperBorder = "0 1px 0 0";
      } else if (index === plansConfig.api.length - 1) {
        wrapperBorder = "0 0 0 1px";
      } else {
        wrapperBorder = "0 1px 0 1px";
      }
      return (
        <Plan
          wrapperBorder={wrapperBorder}
          wrapperWidth={wrapperWidth}
          key={item.id + index}
          plan={item}
          lang={props.lang}
          onInvoiceClick={props.onInvoiceClick}
          backgroundColor={index > 2 ? 'black':'blue'}
        />
      );
    });
  }
};

const mapStateToProps = (state) => ({
  lang: state.request.lang,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...RequestActions,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPlans);
